import { Component } from '@angular/core';

@Component({
  selector: 'app-shop-stock',
  templateUrl: './shop-stock.html',
  styleUrl: './shop-stock.css',
})
export class ShopStock {}
